module.exports = "/images/supernova_spinner.svg?c0962b76711868efa76b0d840956c6e7";